import { render, staticRenderFns } from "./bindChildren.vue?vue&type=template&id=35fc24ef&"
import script from "./bindChildren.vue?vue&type=script&lang=js&"
export * from "./bindChildren.vue?vue&type=script&lang=js&"
import style0 from "./bindChildren.vue?vue&type=style&index=0&id=35fc24ef&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports